import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

import CustomLoader from "../CustomLoader/CustomLoader";
import Toast from "../../components/Toast/Toast";
import LanguagePreferencePopup from "../LanguagePreferencePopup/LanguagePreferencePopup";
import {
  getUserData,
  setCurrentUserData,
} from "../../Store/UserProfile/userProfileActions";
import { resetRedirectUserFromDefaultPage } from "../../Store/Login/loginActions";
import { resetToastDetails } from "../../Store/ToastDetails/toastDetailsActions";
import { getFamilyMembersDetails } from "../../Store/FamilyMembers/familyMembersActions";
import { changeLanguage } from "../../Store/LanguageReducer/languageAction";
import { setItem } from "../../Auth/localStorageService";
import { removeSessionItem } from "../../Auth/sessionStorageService";
import { localeMap } from "../../consts/constant";
import { updateLanguagePreference } from "../../utils/apiService/accountApiService";
import { SHOW_TOAST_MESSAGE_DURATION } from "../../consts/toastShowDuration";
import { styles } from "./LayoutStyles";

const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const isLoading = useSelector((state) => {
    return state.userProfile.showUserProfileLoader;
  });
  const userData = useSelector(
    (state) => state?.userProfile?.currentUserData?.data,
  );
  const fullUserData = useSelector(
    (state) => state?.userProfile?.currentUserData,
  );

  const { firstName } = userData || {};

  const { toastDetails } = useSelector((state) => {
    return state.toastDetails;
  });
  const { isErrorLoadingUserDetails } = useSelector(
    (state) => state.userProfile,
  );
  const { redirectRouteFromDefaultScreen } = useSelector(
    (state) => state.login,
  );

  const [showLanguagePopup, setShowLanguagePopup] = useState(false);

  const handleLanguageSelect = async (langKey) => {
    dispatch(changeLanguage(langKey));
    setItem("language", langKey);
    removeSessionItem("languageSessionOnly");
    setShowLanguagePopup(false);
    if (localeMap(langKey) !== userData?.languagePreferred) {
      await updateLanguagePreference(langKey);
    }
    dispatch(
      setCurrentUserData({
        ...fullUserData,
        data: {
          ...userData,
          languagePreferred: localeMap(langKey),
        },
      }),
    );
  };

  const handleCloseLanguagePopup = () => {
    setShowLanguagePopup(false);
  };

  useEffect(() => {
    dispatch(
      getUserData((data) => {
        if (data && !data.languagePreferred) {
          setShowLanguagePopup(true);
        }
      }),
    );
    dispatch(getFamilyMembersDetails());
    if (redirectRouteFromDefaultScreen) {
      history.push(redirectRouteFromDefaultScreen);
      dispatch(resetRedirectUserFromDefaultPage());
    }
  }, []);

  const closeErrorToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(resetToastDetails());
  };

  return (
    <React.Fragment>
      {!isErrorLoadingUserDetails ? (
        <React.Fragment>
          {!!toastDetails.message && (
            <Box sx={styles.toastContainer}>
              <Toast
                open={!!toastDetails.message}
                closeHandler={closeErrorToast}
                customToastStyle={styles.toastContent}
                alertMessage={toastDetails.message}
                severity="error"
                autoHideDuration={SHOW_TOAST_MESSAGE_DURATION}
              />
            </Box>
          )}
          {isLoading ? <CustomLoader /> : null}
          {firstName && !isLoading ? children : null}
        </React.Fragment>
      ) : null}
      <LanguagePreferencePopup
        open={showLanguagePopup}
        onSelect={handleLanguageSelect}
        onClose={handleCloseLanguagePopup}
      />
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
